export const USER_TYPE_STANDARD = "regular";
export const USER_TYPE_MANAGER = "manager";
export const USER_TYPE_ADMIN = "admin";
